// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_337041', '__Montserrat_Fallback_337041'","fontStyle":"normal"},"className":"__className_337041"};